import type { AppLanguageCode } from '@/i18n/languages';

interface FlagProps {
  className?: string;
}

export function FrenchFlag({ className }: FlagProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 900 600"
      className={className}
      aria-hidden="true"
    >
      <rect width="900" height="600" fill="#ED2939" />
      <rect width="600" height="600" fill="#fff" />
      <rect width="300" height="600" fill="#002395" />
    </svg>
  );
}

export function USFlag({ className }: FlagProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 190 100"
      className={className}
      aria-hidden="true"
    >
      {Array.from({ length: 13 }, (_, i) => (
        <rect
          key={i}
          x="0"
          y={i * (100 / 13)}
          width="190"
          height={100 / 13 + 0.5}
          fill={i % 2 === 0 ? '#B22234' : '#FFFFFF'}
        />
      ))}
      <rect x="0" y="0" width="76" height={(100 / 13) * 7} fill="#3C3B6E" />
    </svg>
  );
}

export function SpanishFlag({ className }: FlagProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 750 500"
      className={className}
      aria-hidden="true"
    >
      <rect width="750" height="500" fill="#AA151B" />
      <rect y="125" width="750" height="250" fill="#F1BF00" />
    </svg>
  );
}

export function BrazilFlag({ className }: FlagProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 720 504"
      className={className}
      aria-hidden="true"
    >
      <rect width="720" height="504" fill="#009C3B" />
      <path d="M360 43 677 252 360 461 43 252Z" fill="#FFDF00" />
      <circle cx="360" cy="252" r="105" fill="#002776" />
    </svg>
  );
}

const FLAG_BY_LANGUAGE: Record<AppLanguageCode, (props: FlagProps) => React.JSX.Element> = {
  fr: FrenchFlag,
  en: USFlag,
  es: SpanishFlag,
  pt: BrazilFlag,
};

export function LanguageFlag({ code, className }: FlagProps & { code: AppLanguageCode }) {
  const Flag = FLAG_BY_LANGUAGE[code];
  return <Flag className={className} />;
}
